import produce from 'immer';
import getStatusMessagePriority from 'utils/fuctions/getStatusMessagePriority';

const INITIAL_STATE = {
  conversation: {}
};

export default function conversation(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@CONVERSATION_IN_ATTENDANCE/ADD_INIT_CONVERSATION':
      return produce(state, (draft) => {
        draft.conversation = action.payload.conversation;
      });
    case '@CONVERSATION_IN_ATTENDANCE/REMOVE_CONVERSATION_IN_ATTENDANCE':
      return produce(state, (draft) => {
        draft.conversation = {};
      });
    case '@CONVERSATION_IN_ATTENDANCE/CHECK_REMOVE_CONVERSATION_IN_ATTENDANCE': {
      const copy = { ...state };
      if (
        action.payload.id === state?.conversation?.id ||
        action.payload.id === state?.conversation?._id
      ) {
        copy.conversation = {};
        return copy;
      }
      return state;
    }

    case '@CONVERSATION_IN_ATTENDANCE/ADD_MESSAGE_CONVERSATION_IN_ATTENDANCE':
      return produce(state, (draft) => {
        if (draft.conversation.mensagens === null) return;
        const copyData = { ...draft };

        if (!copyData?.conversation?._id && copyData?.conversation?.id) {
          copyData.conversation._id = copyData.conversation.id;
        }
        if (action?.payload?.idDaConversa === copyData?.conversation?._id) {
          if (draft?.conversation?.mensagens) {
            const incomingMessage = action?.payload?.message;
            // Trata das mensagens que chegam com um temp_id, que são mensagens otimistas
            // Tarefa de referência: https://app.clickup.com/t/86afw9w92
            if (incomingMessage?.temp_id) {
              // Mensagem otimista ou mensagem real chegando com um temp_id
              const existingIndex = draft.conversation.mensagens.findIndex(
                (msg) => msg.temp_id === incomingMessage.temp_id
              );

              if (existingIndex > -1) {
                // Se já existe uma mensagem "fake" com esse temp_id, nós sobrecrevemos com os dados reais, 
                // mas fazendo merge para não perder blob URL se a API omitir a informação.
                
                const currentMsg = draft.conversation.mensagens[existingIndex];
                
                // Evitar que uma URL nula da API sobreponha o Blob local
                if (!incomingMessage.url) delete incomingMessage.url;
                if (!incomingMessage.source) delete incomingMessage.source;

                draft.conversation.mensagens[existingIndex] = {
                  ...currentMsg,
                  ...incomingMessage
                };
              } else {
                draft.conversation.mensagens.push(incomingMessage);
              }
            } else {
              draft.conversation.mensagens.push(incomingMessage);
            }
          }
        }
      });
    case '@CONVERSATION_IN_ATTENDANCE/UPDATE_TAGS_CONVERSATION_IN_ATTENDANCE':
      return produce(state, (draft) => {
        const copyData = { ...draft };

        if (!copyData?.conversation?._id && copyData?.conversation?.id) {
          copyData.conversation._id = copyData.conversation.id;
        }
        if (
          action?.payload?.contactId === copyData?.conversation?.cliente?.id
        ) {
          draft.conversation.tags = action?.payload?.newContactTag;
          draft.conversation.cliente.tags = action?.payload?.newContactTag;
        }
      });

    case '@CONVERSATION_IN_ATTENDANCE/ADD_WHATSAPP_MESSAGE_ID_CONVERSATION_IN_ATTENDANCE':
      return produce(state, (draft) => {
        if (draft.conversation.mensagens === null) return;
        draft.conversation.mensagens = draft?.conversation?.mensagens.map(
          (mensagem) => {
            if (
              mensagem.texto === action.payload.message.texto &&
              mensagem.cliente_ou_atendente ===
                action.payload.message.cliente_ou_atendente &&
              mensagem.escrita_por === action.payload.message.escrita_por
            ) {
              mensagem.id_mensagem_whatsapp =
                action.payload.message.id_mensagem_whatsapp;
            }
            return mensagem;
          }
        );
      });
    case '@CONVERSATION_IN_ATTENDANCE/UPDATE_STATUS_MESSAGE_CONVERSATION_IN_ATTENDANCE':
      // eslint-disable-next-line no-case-declarations
      const newState = produce(state, (draft) => {
        if (!draft?.conversation?.mensagens) return;

        const eventMsg = action?.payload?.eventMessage;
        if (!eventMsg) return;

        const messageIndex = draft.conversation.mensagens.findIndex(
          (mensagem) =>
            mensagem.id_mensagem_whatsapp === eventMsg.idMensagemWhatsapp ||
            mensagem.id_mensagem_whatsapp === eventMsg.id_mensagem_whatsapp ||
            mensagem.mid === eventMsg.mid
        );

        if (messageIndex !== -1) {
          const message = draft.conversation.mensagens[messageIndex];
          message.status = getStatusMessagePriority(
            message.status,
            eventMsg.status
          );

          if (
            eventMsg.metaMessageId &&
            !message.metaMessageId?.startsWith('wamid')
          ) {
            message.metaMessageId = eventMsg.metaMessageId;
            message.id_mensagem_whatsapp = eventMsg.metaMessageId;
          }
        }
      });
      return newState;

    case '@CONVERSATION_IN_ATTENDANCE/UPDATE_WHATSAPP_MESSAGE_ID_CONVERSATION_IN_ATTENDANCE':
      // eslint-disable-next-line no-case-declarations
      const stat = produce(state, (draft) => {
        if (!draft?.conversation?.mensagens) return;

        const messageIndex = draft.conversation.mensagens.findIndex(
          (mensagem) => mensagem.mid === action.payload.eventPayload.mid
        );

        if (messageIndex !== -1) {
          draft.conversation.mensagens[messageIndex].id_mensagem_whatsapp =
            action.payload.eventPayload.id_mensagem_whatsapp;
          draft.conversation.mensagens[messageIndex].metaMessageId =
            action.payload.eventPayload.id_mensagem_whatsapp;
        }
      });
      return stat;

    case '@CONVERSATION_IN_ATTENDANCE/DELETE_MESSAGE_CONVERSATION_IN_ATTENDANCE':
      // eslint-disable-next-line no-case-declarations
      const _newState = produce(state, (draft) => {
        if (!draft?.conversation?.mensagens) return;
        const copy = [...draft.conversation.mensagens];
        const index = copy.findIndex((mensagem) => {
          return mensagem.mid === action.payload.message.mid;
        });
        if (index === -1) {
          return;
        }
        copy.splice(index, 1);
        draft.conversation.mensagens = copy;
      });
      return JSON.stringify(_newState) === JSON.stringify(state)
        ? state
        : _newState;

    default:
      return state;
  }
}